import './types';

const hideElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.add('d-none');
    }
};

const showElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.remove('d-none');
    }
};

const initVideosInfiniteScroll = (): void => {
    const loadMoreButton = document.getElementById('load-more-videos-btn');
    const nextPage = document.querySelector('.next-page');

    hideElement(loadMoreButton);

    if (!nextPage) {
        return;
    }

    const videoContainer = document.querySelector<HTMLElement>('.video-container');

    if (!videoContainer) {
        return;
    }

    const page = parseInt(videoContainer.dataset.infiniteScrollPage || '1', 10);
    const totalPages = parseInt(videoContainer.dataset.infiniteScrollTotalPages || '1', 10);

    const infScroll = new window.InfiniteScroll(videoContainer, {
        path: '.next-page',
        append: '.v-component',
        button: '.load-more-btn',
        status: '.page-load-status',
        history: 'replace',
    });

    infScroll.on('request', () => {
        hideElement(loadMoreButton);
    });

    infScroll.on('load', () => {
        if (infScroll.loadCount % 2 === 0 && (infScroll.loadCount + page) < totalPages) {
            infScroll.loadOnScroll = false;
            showElement(loadMoreButton);
        } else {
            infScroll.loadOnScroll = true;
            hideElement(loadMoreButton);
        }
    });
};

const initVideos = (): void => {
    if (typeof window.InfiniteScroll === 'undefined') {
        setTimeout(initVideos, 50);

        return;
    }

    initVideosInfiniteScroll();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initVideos);
} else {
    initVideos();
}
